import { en } from "./en";
import { es } from "./es";
import { pt } from "./pt";
var locales = {
  es: es,
  en: en,
  pt: pt
};
export * from "./types";
export * from "./constants";
export default locales;